
define('template!chartViewTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<canvas class="chart-canvas"></canvas>\n';

}
return __p
};});

